import { entregaPorPath } from "./entregas";

/**
 * Enlace de firma de la autorización de uso de imagen de cada entrega:
 * /entregas/<evento>/autorizacion. Es el que se le manda al cliente que dijo
 * que sí al portafolio (ver ExperienciaForm y send-autorizacion).
 *
 * Existe una por entrega, sin token: igual que la página de entrega, quien
 * tiene el enlace puede verla. Cada firma queda a nombre y RUT de quien firma,
 * así que el mismo enlace sirve para la novia, el novio o los dos padres de
 * un menor, cada uno por separado.
 */

const SUFIJO = "/autorizacion";

export const rutaAutorizacion = (entrega) => `${entrega.path}${SUFIJO}`;

/*
 * Este navegador ya firmó la autorización de esa entrega: la página de la
 * entrega deja de pedirle la firma. Es solo una comodidad; la prueba de la
 * firma está en omega_autorizaciones.
 */
const claveFirma = (path) => `omega:autorizacion:${path}`;

export const recordarFirma = (path) => {
  try {
    window.localStorage.setItem(claveFirma(path), new Date().toISOString());
  } catch {
    /* Sin almacenamiento solo se pierde el recordatorio. */
  }
};

export const firmaRecordada = (path) => {
  try {
    return Boolean(window.localStorage.getItem(claveFirma(path)));
  } catch {
    return false;
  }
};

/** Entrega cuya página de autorización es esta ruta, o null. */
export const entregaDeAutorizacion = (pathname) =>
  pathname.endsWith(SUFIJO) ? entregaPorPath(pathname.slice(0, -SUFIJO.length)) : null;
